import React from 'react';

import { Button, Spinner, Text } from '@change/ds-core-ui';
import { ArrowRightIcon } from '@change/ds-icons';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { useHeroTypingPlaceholder } from '#src/app/pages/homepage/shared/hooks';

import { HeroTypingOverlay } from '../HeroTypingOverlay';
import { PromptInput, PromptInputActions, PromptInputTextarea } from '../PromptInput';

import { useSapIssueForm } from './hooks/useSapIssueForm';

export const SapIssueForm: React.FC<EmptyProps> = () => {
	const { translate } = useI18n();
	const {
		data: { isSubmitting },
		actions: { onSubmit },
	} = useSapIssueForm();
	// onSubmit reads the value via FormData; it's only tracked here so the overlay can hide on input.
	const {
		data: { value: issue, placeholder, showOverlay, descriptionId },
		actions: { onValueChange: setIssue },
	} = useHeroTypingPlaceholder();

	const imageButtonIcon = isSubmitting ? <Spinner className="size-4" /> : <ArrowRightIcon />;
	const ariaLabel = isSubmitting
		? translate('corgi.homepage.hero_section.input_prompt_submit_button_loading')
		: translate('corgi.homepage.hero_section.input_prompt_submit_button');

	return (
		<div className="mb-3 flex w-full flex-col items-center justify-center lg:mb-3">
			<div className="flex w-full max-w-[600px] flex-col gap-4">
				<div>
					<Text className="text-center" variant="body" size="large" fontWeight="bold" as="h2" id="sap-input-heading">
						<Translate value="corgi.homepage.hero_section.input_prompt_label_alt" />
					</Text>
				</div>
				<form onSubmit={onSubmit} data-qa="sap-input-prompt-form">
					<PromptInput data-qa="sap-prompt" className="group" value={issue} onValueChange={setIssue}>
						<PromptInputTextarea
							maxLength={500}
							name="issue"
							placeholder={placeholder}
							aria-labelledby="sap-input-heading"
							aria-describedby={showOverlay ? descriptionId : undefined}
							enterKeyHint="send"
						/>

						{showOverlay && <HeroTypingOverlay descriptionId={descriptionId} />}

						<PromptInputActions data-qa="prompt-input-actions">
							<Button
								aria-label={ariaLabel}
								aria-live="polite"
								className="bg-fill-interactive ml-auto h-11 w-11 rounded-full"
								iconOnly
								leadingIcon={imageButtonIcon}
								variant="primary"
								type="submit"
								data-qa="prompt-input-actions-button"
							/>
						</PromptInputActions>
					</PromptInput>
				</form>
			</div>
		</div>
	);
};
